// The hub's own font files, for the tool runner (toolRunner.js): the same files src/styles/fonts.css
// serves, from the @fontsource packages, each weight the hub bundles. The build gives each import
// its address under /assets/ (scripts/build.mjs, the file loader), so a tool gets the hub's copy of
// a family it names, read from this site and handed to the tool as data. Nothing loads from a
// public CDN.
//
//   await toolFontsCss(['Archivo', 'IBM Plex Sans'])   @font-face rules with the files as data
import archivo500 from '@fontsource/archivo/files/archivo-latin-500-normal.woff2'
import archivo600 from '@fontsource/archivo/files/archivo-latin-600-normal.woff2'
import archivo700 from '@fontsource/archivo/files/archivo-latin-700-normal.woff2'
import archivo800 from '@fontsource/archivo/files/archivo-latin-800-normal.woff2'
import plex400 from '@fontsource/ibm-plex-sans/files/ibm-plex-sans-latin-400-normal.woff2'
import plex500 from '@fontsource/ibm-plex-sans/files/ibm-plex-sans-latin-500-normal.woff2'
import plex600 from '@fontsource/ibm-plex-sans/files/ibm-plex-sans-latin-600-normal.woff2'
import inter400 from '@fontsource/inter/files/inter-latin-400-normal.woff2'
import inter500 from '@fontsource/inter/files/inter-latin-500-normal.woff2'
import inter600 from '@fontsource/inter/files/inter-latin-600-normal.woff2'
import interTight700 from '@fontsource/inter-tight/files/inter-tight-latin-700-normal.woff2'
import manrope400 from '@fontsource/manrope/files/manrope-latin-400-normal.woff2'
import manrope500 from '@fontsource/manrope/files/manrope-latin-500-normal.woff2'
import manrope600 from '@fontsource/manrope/files/manrope-latin-600-normal.woff2'
import manrope700 from '@fontsource/manrope/files/manrope-latin-700-normal.woff2'
import manrope800 from '@fontsource/manrope/files/manrope-latin-800-normal.woff2'
import anton400 from '@fontsource/anton/files/anton-latin-400-normal.woff2'
import { fontFaceCss } from './toolRunner.js'

const FILES = {
  Archivo: [[500, archivo500], [600, archivo600], [700, archivo700], [800, archivo800]],
  'IBM Plex Sans': [[400, plex400], [500, plex500], [600, plex600]],
  Inter: [[400, inter400], [500, inter500], [600, inter600]],
  'Inter Tight': [[700, interTight700]],
  Manrope: [[400, manrope400], [500, manrope500], [600, manrope600], [700, manrope700], [800, manrope800]],
  Anton: [[400, anton400]],
}

// Each file read once a visit, as data
const read = new Map()
function asData(url) {
  if (!read.has(url)) {
    read.set(url, fetch(url).then(res => {
      if (!res.ok) throw new Error(`font ${res.status}`)
      return res.arrayBuffer()
    }).then(buf => {
      let bin = ''
      const bytes = new Uint8Array(buf)
      for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode(...bytes.subarray(i, i + 0x8000))
      return `data:font/woff2;base64,${btoa(bin)}`
    }).catch(err => { read.delete(url); throw err }))
  }
  return read.get(url)
}

// The rules for the families named; a file that won't load is left out, and the tool falls back to
// the next font in its own list
export async function toolFontsCss(families) {
  const fonts = {}
  await Promise.all((families || []).filter(f => FILES[f]).map(async family => {
    const faces = await Promise.all(FILES[family].map(([weight, url]) => asData(url).then(data => ({ weight, data })).catch(() => null)))
    fonts[family] = faces.filter(Boolean)
  }))
  return fontFaceCss(fonts)
}
